import { GridOptions } from '@ag-grid-community/core'
import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { CashBreakSuggestion } from '../../models/copilot.model'
import { CashBreakSuggestionsService } from '../../services/cash-break/cash-break-suggestions.service'

export interface ActionResponse<T> {
  data?: T
}
export interface Accounts {
  clientName: never
  startDate: never
  endDate: never
}
@Component({
  selector: 'hs-cash-break-suggestions-modal',
  templateUrl: './cash-break-suggestions-modal.component.html',
  styleUrls: ['./cash-break-suggestions-modal.component.scss'],
})
export class CashBreakSuggestionsModalComponent {
  _cashBreakSuggestions: CashBreakSuggestion[] = []
  @Input() set cashBreakSuggestions(
    cashBreakSuggestions: CashBreakSuggestion[],
  ) {
    this._cashBreakSuggestions = cashBreakSuggestions
  }

  @Input() acctId = ''
  @Input() breakId = ''
  columnField: string[] = []
  accounts: Accounts | undefined
  constructor(
    public activeModal: NgbActiveModal,
    public cashBreakSuggestionService: CashBreakSuggestionsService,
  ) {}
  cwGridOptions: GridOptions = {
    defaultColDef: {
      menuTabs: [],
      sortable: false,
    },
    sideBar: false,
    enableCellChangeFlash: true,
    enableRangeSelection: true,
    suppressMultiRangeSelection: false,
    enableFillHandle: true,
    fillHandleDirection: 'y',
    columnDefs: [
      { field: 'tranId', headerName: 'Transaction Id' },
      { field: 'accountId', headerName: 'Account Id' },
      { field: 'secIdentifier', headerName: 'Asset ID' },
      { field: 'postDate', headerName: 'Post Date' },
      { field: 'amount', headerName: 'Amount' },
      { field: 'currencyCode', headerName: 'Currency' },
    ],
  }

  exGridOptions: GridOptions = {
    defaultColDef: {
      menuTabs: [],
      sortable: false,
    },
    sideBar: false,
    enableCellChangeFlash: true,
    enableRangeSelection: true,
    suppressMultiRangeSelection: false,
    enableFillHandle: true,
    fillHandleDirection: 'y',
    columnDefs: [
      { field: 'extTranId', headerName: 'Ext Transaction Id' },
      { field: 'accountId', headerName: 'Account Id' },
      { field: 'secIdentifier', headerName: 'Asset ID' },
      { field: 'postDate', headerName: 'Post Date' },
      { field: 'amount', headerName: 'Amount' },
      { field: 'currencyCode', headerName: 'Currency' },
    ],
  }

  filterTransactions(cashBreakSuggestion: CashBreakSuggestion) {
    this.activeModal.dismiss()
    this.cashBreakSuggestionService.filterTransactionsBySuggestion(
      cashBreakSuggestion,
    )
  }

  submitSuggestions(cashBreakSuggestion: CashBreakSuggestion) {
    this.cashBreakSuggestionService
      .submitSuggestions(cashBreakSuggestion, this.acctId, this.breakId)
      .then(data => {
        if (data != undefined) this.activeModal.dismiss()
      })
  }
}
